import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

console.log('Supabase config:', {
  url: supabaseUrl,
  hasKey: !!supabaseAnonKey,
  keyLength: supabaseAnonKey?.length
})

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables')
}

// Snapshot of the auth params Supabase puts in the URL hash (password recovery,
// email confirmation, link errors). This MUST be read before createClient runs:
// the client consumes the hash and strips it from the URL during initialization.
const initialHashParams = new URLSearchParams(window.location.hash.replace(/^#/, ''))

export const initialAuthRedirect = {
  hash: window.location.hash,
  isRecovery: initialHashParams.get('type') === 'recovery',
  errorCode: initialHashParams.get('error_code') || initialHashParams.get('error'),
  errorDescription: initialHashParams.get('error_description')?.replace(/\+/g, ' ') || '',
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// Types for our database tables
export interface UserProfile {
  id: string
  username?: string
  full_name?: string
  avatar_url?: string
  created_at: string
  updated_at: string
}

export interface Prompt {
  id: string
  user_id: string
  context: string
  role: string
  action: string
  format: string
  tone_scores: {
    professional: number
    academic: number
    fact_based: number
  }
  additional_tones: string[]
  example?: string
  final_prompt: string
  created_at: string
  updated_at: string
}


